import { useState, useEffect } from "react";
import apiService from "../services/api";
import eventsLocal from "../data/events";

export const useRelatedLinks = (event) => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!event?.id) {
      setLoading(false);
      return;
    }

    const fetchLinks = async () => {
      try {
        const res = await apiService.get(
          `/event-related-links/event/${event.id}`
        );
        const apiLinks = res.data || res || [];

        if (Array.isArray(apiLinks) && apiLinks.length > 0) {
          setLinks(apiLinks);
        } else {
          const offlineEvent = eventsLocal.find(
            (e) => e.id === event.id || e.event_public_id === event.event_public_id
          );
          setLinks(offlineEvent?.related_links || []);
        }
      } catch (err) {
        console.warn("Failed to fetch related links:", err.message);
        const offlineEvent = eventsLocal.find(
          (e) => e.id === event.id || e.event_public_id === event.event_public_id
        );
        setLinks(offlineEvent?.related_links || []);
      } finally {
        setLoading(false);
      }
    };

    fetchLinks();
  }, [event?.id, event?.event_public_id]);

  return { links, loading };
};
